<script lang="ts">
	import { Button } from "flowbite-svelte-v1";
	import { twMerge } from "tailwind-merge";
	import { ASPECT_RATIOS } from "#lib/components/images/constants.js";
	import { matchAspectRatioPreset } from "#lib/components/images/utils.js";

	interface Props {
		aspectRatio: number | undefined;
		setAspectRatio?: (aspectRatio?: number) => void;
	}

	let { aspectRatio = $bindable(undefined), setAspectRatio }: Props = $props();

	let selectedItem = $derived(ASPECT_RATIOS.find(item => item.ratio !== undefined && item.ratio === matchAspectRatioPreset(aspectRatio))?.name ?? "Freeform");

	const ICON_SIZE = 14;

	function iconStyle(ratio: number | undefined): string {
		const width = !ratio || ratio >= 1 ? ICON_SIZE : ICON_SIZE * ratio;
		const height = !ratio || ratio <= 1 ? ICON_SIZE : ICON_SIZE / ratio;
		return `width: ${width}px; height: ${height}px;`;
	}

	function handleSelect(ratio: number | undefined) {
		aspectRatio = ratio;
		setAspectRatio?.(ratio);
	}
</script>

<div class="flex flex-row items-center justify-center gap-1">
	{#each ASPECT_RATIOS as option (option.name)}
		<Button color="alternative" size="md" class={twMerge("rounded-3xl", selectedItem === option.name ? "text-primary-700 bg-gray-100" : "text-gray-800")} data-action-name="aspect-ratio-picker" data-action-title={option.name} onclick={() => handleSelect(option.ratio)}>
			{#if option.ratio}
				<span class={twMerge("mr-1.5 inline-block shrink-0 border", selectedItem === option.name ? "border-primary-700 " : "border-gray-500")} style={iconStyle(option.ratio)}></span>
			{/if}
			{option.name}
		</Button>
	{/each}
</div>
